const BRAZIL_COUNTRY_PREFIX = "55";

const format0800 = (digits: string): string => {
  if (digits.length <= 4) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const digits = phoneNumber.replace(/\D/g, "");
  const withoutCountry =
    digits.startsWith(BRAZIL_COUNTRY_PREFIX) && digits.length > 11
      ? digits.slice(BRAZIL_COUNTRY_PREFIX.length)
      : digits;

  if (withoutCountry.startsWith("0800")) {
    return format0800(withoutCountry);
  }

  if (withoutCountry.length === 10) {
    return withoutCountry.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
  }

  if (withoutCountry.length === 11) {
    return withoutCountry.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
  }

  return phoneNumber;
};

